import { useMemo } from 'react'

export const useIsFreeConsultation = (total?: number) => {
  const isFreeConsultation = useMemo(() => {
    if (typeof total === 'number') return total === 0
    return false
    // const spe = router.query.spe
    // const isPatientArea = router.pathname.includes('/me')
    //
    // if (isPatientArea) return false
    //
    // return ['/calvicie'].includes(router.pathname) || (typeof spe === 'string' && ['hair_loss'].includes(spe))
  }, [total])

  return {
    isFreeConsultation
  }
}
